// extracted by mini-css-extract-plugin
export default {"courses":"styles_courses__+7Hax","__in":"styles___in__0L9Fr","title":"styles_title__YpOrc","sub_title":"styles_sub_title__S4olC","list":"styles_list__JlxbB"};